export default "__VITE_ASSET__fb5e860b__"